var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BlockUI',{attrs:{"message":_vm.msg}},[_c('img',{attrs:{"src":_vm.url,"alt":"Loading","width":"60"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }